export * from './customer-configuration.component';